import { Box, Typography } from "@mui/material";
import { Close, Done } from "@mui/icons-material";

export function ReadOnlyCarbonOffsetting({
  usedToOffset = false,
}: {
  usedToOffset: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {usedToOffset ? (
        <>
          <Done fontSize="large" color="success" />
          <Typography variant="body1">Used for Carbon Offsetting</Typography>
        </>
      ) : (
        <>
          <Close fontSize="large" color="error" />
          <Typography variant="body1">
            Not used for Carbon Offsetting
          </Typography>
        </>
      )}
    </Box>
  );
}

export default ReadOnlyCarbonOffsetting;
